import { storage } from '@digital/ui';

export const hasPermission = (permissions: string[]) => {
  let userPermissions = storage.getPermissions();
  if (userPermissions.some(p1 => permissions.some(p2 => p2 == p1))) return true;
  return false;
};
